export const ARTIFACT_SCROLL_MESSAGE = "workflow86-artifact-scroll";

// Iframes auto-resize to their full content height, so they never scroll
// internally. When the pointer is over the iframe the browser routes wheel
// events to the iframe document, where they die instead of chaining to the
// surrounding scroll container. This inline script forwards any wheel delta the
// iframe cannot consume itself back to the parent. Assumes `frameId` is in scope.
export function artifactWheelForwardScript() {
  return `
      (() => {
        const SCROLL_MESSAGE = ${JSON.stringify(ARTIFACT_SCROLL_MESSAGE)};
        function consumesWheel(target, deltaX, deltaY) {
          let node = target;
          while (node && node.nodeType === 1 && node !== document.documentElement) {
            const style = getComputedStyle(node);
            const scrollableY =
              /(auto|scroll)/.test(style.overflowY) &&
              node.scrollHeight > node.clientHeight;
            const scrollableX =
              /(auto|scroll)/.test(style.overflowX) &&
              node.scrollWidth > node.clientWidth;
            if (
              scrollableY &&
              ((deltaY < 0 && node.scrollTop > 0) ||
                (deltaY > 0 && node.scrollTop + node.clientHeight < node.scrollHeight))
            ) {
              return true;
            }
            if (
              scrollableX &&
              ((deltaX < 0 && node.scrollLeft > 0) ||
                (deltaX > 0 && node.scrollLeft + node.clientWidth < node.scrollWidth))
            ) {
              return true;
            }
            node = node.parentElement;
          }
          return false;
        }
        window.addEventListener(
          'wheel',
          event => {
            let deltaX = event.deltaX;
            let deltaY = event.deltaY;
            if (event.deltaMode === 1) {
              deltaX *= 16;
              deltaY *= 16;
            } else if (event.deltaMode === 2) {
              deltaX *= window.innerWidth;
              deltaY *= window.innerHeight;
            }
            if (consumesWheel(event.target, deltaX, deltaY)) return;
            event.preventDefault();
            parent.postMessage({ type: SCROLL_MESSAGE, frameId, deltaX, deltaY }, '*');
          },
          { passive: false }
        );
      })();`;
}

export function scrollFrameAncestor(iframe, deltaX, deltaY) {
  let node = iframe?.parentElement || null;
  while (node) {
    const style = window.getComputedStyle(node);
    const canScrollY =
      /(auto|scroll)/.test(style.overflowY) &&
      node.scrollHeight > node.clientHeight + 1;
    const canScrollX =
      /(auto|scroll)/.test(style.overflowX) &&
      node.scrollWidth > node.clientWidth + 1;
    if (canScrollY || canScrollX) {
      node.scrollBy({
        top: canScrollY ? deltaY : 0,
        left: canScrollX ? deltaX : 0,
      });
      return true;
    }
    node = node.parentElement;
  }
  // Last resort when the page itself is the scrolling document.
  const root = document.scrollingElement || document.documentElement;
  if (root && root.scrollHeight > root.clientHeight + 1) {
    root.scrollBy(0, deltaY);
    return true;
  }
  return false;
}
